import { MallApi } from "@/api/MallApi";

const mallApi = new MallApi();
const basicUrl = "/gw/app";

const orderDetailPageUrl = {
  orderDetailUrl: basicUrl + "/lywl/employee/order/orderDetail",
  cancleUrl: basicUrl + "/lywl/employee/order/cancel",
  getPayUrl: basicUrl + '/lywl/employee/order/getPayUrl',
};

/**订单详情 */
export const queryOrderDetail = (params?: any) => {
  return mallApi.Post<any>(orderDetailPageUrl.orderDetailUrl, params, {
    cacheData: false,
  });
};

/**取消订单 */
export const orderCancel = (params?: any) => {
  return mallApi.Post<any>(orderDetailPageUrl.cancleUrl, params, {
    cacheData: false,
  });
};

/**去支付 */
export const getOrderPay = (params?: any) => {
    return mallApi.Post<any>(orderDetailPageUrl.getPayUrl, params, {
      cacheData: false,
    });
  };
